/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_LoadingInputs */



/**
* | output |
* | --- |
* | "Loading this conversation…" |
*
* @param {Meeting_LoadingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_loading = /** @type {((inputs?: Meeting_LoadingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_LoadingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je gesprek wordt geladen…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement de votre conversation…")
	return /** @type {LocalizedString} */ ("Loading this conversation…")
});